module.exports = __webpack_public_path__ + "static/media/mk.25a61913.png";